/* EWP theme — vanilla JS, no dependencies. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var toastTimer;
  function toast(msg, isError) {
    var el = $('#ewp-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked'); }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked'); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) openDrawer($('[data-mobile-nav]'));
    if (t.closest('[data-menu-close]')) closeDrawer($('[data-mobile-nav]'));
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer($('[data-cart-drawer]')); }
    if (t.closest('[data-cart-close]')) closeDrawer($('[data-cart-drawer]'));
    if (t.closest('[data-search-open]')) { var p = $('[data-search-panel]'); if (p) { p.hidden = false; $('input[type=search]', p).focus(); } }
    if (t.closest('[data-search-close]')) $('[data-search-panel]').hidden = true;
    var change = t.closest('[data-cart-change]');
    if (change) changeLine(change.getAttribute('data-cart-change'), parseInt(change.getAttribute('data-qty'), 10));
    var minus = t.closest('[data-qty-minus]'), plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var input = (minus || plus).parentNode.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (plus ? 1 : -1));
    }
    var th = t.closest('[data-thumb]');
    if (th) showMedia(th.getAttribute('data-thumb'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    var p = $('[data-search-panel]'); if (p) p.hidden = true;
  });

  /* Cart — Shopify AJAX Cart API + Section Rendering API */
  function refreshCart(sections) {
    var html = sections && sections['cart-drawer'];
    var drawer = $('[data-cart-drawer]');
    if (html && drawer) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    }
    return fetch(window.EWP.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      return cart;
    });
  }
  function changeLine(key, quantity) {
    return fetch(window.EWP.routes.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity), sections: ['cart-drawer'] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { toast(res.description || res.message, true); return; }
      refreshCart(res.sections);
    }).catch(function () { toast('Could not update your bag. Please try again.', true); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart]')) return;
    e.preventDefault();
    if (form.matches('[data-product-form]') && !validateProductForm(form)) return;
    var btn = form.querySelector('[type=submit]');
    if (btn) { if (btn.classList.contains('is-loading')) return; btn.classList.add('is-loading'); }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fetch(window.EWP.routes.cart_add, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || res.message || 'Could not add to bag', true); return; }
        return refreshCart(res.sections).then(function () { openDrawer($('[data-cart-drawer]')); });
      })
      .catch(function () { toast('Could not add to bag. Please try again.', true); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* Product page — variant selection, size mandatory */
  var productForm = $('[data-product-form]');
  var product = null;
  var jsonEl = $('[data-product-json]');
  if (productForm && jsonEl) { try { product = JSON.parse(jsonEl.textContent); } catch (err) { product = null; } }
  function fieldsets() { return $$('[data-option-index]', productForm); }
  function isHidden(fs) { return fs.classList.contains('option--hidden'); }
  function selectedOptions() { return fieldsets().map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
  function findVariant(opts) {
    var fs = fieldsets();
    var matches = product.variants.filter(function (v) {
      return v.options.every(function (val, i) { return (fs[i] && isHidden(fs[i]) && opts[i] === null) || val === opts[i]; });
    });
    return matches.filter(function (v) { return v.available; })[0] || matches[0] || null;
  }
  function money(cents) {
    var cur = window.Shopify && Shopify.currency ? Shopify.currency.active : 'PKR';
    return cur + ' ' + Math.round(cents / 100).toLocaleString('en-PK');
  }
  function updateAvailability() {
    var fs = fieldsets(), opts = selectedOptions();
    fs.forEach(function (f, i) {
      $$('.chip', f).forEach(function (chip) {
        var val = $('input', chip).value;
        var ok = product.variants.some(function (v) {
          return v.available && v.options[i] === val && v.options.every(function (o, j) { return j === i || opts[j] === null || o === opts[j]; });
        });
        chip.classList.toggle('is-unavailable', !ok);
      });
      var chosen = $('[data-option-chosen]', f);
      if (chosen) chosen.textContent = opts[i] && !/stitched/i.test(opts[i]) ? opts[i] : '';
    });
  }
  function onOptionChange() {
    var fs = fieldsets(), opts = selectedOptions();
    updateAvailability();
    var err = $('[data-size-error]', productForm); if (err) err.hidden = true;
    fs.forEach(function (f) { f.classList.remove('is-error'); });
    if (!opts.every(function (o, i) { return o !== null || isHidden(fs[i]); })) return;
    var variant = findVariant(opts);
    var btn = $('[data-add-btn]', productForm);
    if (!variant) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
    $('[data-variant-id]', productForm).value = variant.id;
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'Add to bag' : 'Out of stock';
    var price = $('[data-price]'); if (price) price.textContent = money(variant.price);
    if (variant.featured_media) showMedia(String(variant.featured_media.id));
    var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  }
  function validateProductForm(form) {
    if (!product) return true;
    var missing = fieldsets().filter(function (f) { return !isHidden(f) && !$('input:checked', f); });
    if (!missing.length) {
      var v = findVariant(selectedOptions());
      if (v && !v.available) { toast('This size is out of stock', true); return false; }
      return true;
    }
    missing.forEach(function (f) { f.classList.add('is-error'); });
    var err = $('[data-size-error]', form); if (err) err.hidden = false;
    var isSize = missing[0].getAttribute('data-option-size') === 'true';
    toast(isSize ? 'Please select a size before adding to bag' : 'Please choose ' + $('legend', missing[0]).firstChild.textContent.trim(), true);
    missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }
  if (product) {
    var firstAvail = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    fieldsets().forEach(function (f, i) {
      if (isHidden(f) && firstAvail) {
        var inp = $$('input', f).filter(function (x) { return x.value === firstAvail.options[i]; })[0];
        if (inp) inp.checked = true;
      } else if (f.getAttribute('data-option-size') !== 'true') {
        var visible = $$('.chip:not(.chip--hidden) input', f);
        if (visible.length === 1) visible[0].checked = true;
      }
    });
    productForm.addEventListener('change', function (e) { if (e.target.matches('[data-option-input]')) onOptionChange(); });
    updateAvailability();
  }

  /* Gallery with swipe */
  function showMedia(id) {
    var imgs = $$('[data-media-id]');
    if (!imgs.some(function (i) { return i.getAttribute('data-media-id') === id; })) return;
    imgs.forEach(function (i) { i.classList.toggle('is-active', i.getAttribute('data-media-id') === id); });
    $$('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
  }
  var gallery = $('[data-gallery-main]');
  if (gallery) {
    var gx = null;
    gallery.addEventListener('touchstart', function (e) { gx = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (gx === null) return;
      var dx = e.changedTouches[0].clientX - gx; gx = null;
      if (Math.abs(dx) < 40) return;
      var imgs = $$('[data-media-id]', gallery);
      var idx = imgs.findIndex(function (i) { return i.classList.contains('is-active'); });
      var next = imgs[(idx + (dx < 0 ? 1 : -1) + imgs.length) % imgs.length];
      if (next) showMedia(next.getAttribute('data-media-id'));
    });
  }

  /* Hero slider — auto-advance + finger/mouse swipe, no arrows */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-hero-slide]', hero), dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    var active = 0, timer = null, paused = false;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 3000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) {
      active = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === active); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === active); });
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() { stop(); if (!reduce && !paused && document.visibilityState === 'visible') timer = setInterval(function () { go(active + 1); }, interval); }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); start(); }); });
    hero.addEventListener('mouseenter', function () { paused = true; stop(); });
    hero.addEventListener('mouseleave', function () { paused = false; start(); });
    hero.addEventListener('focusin', function () { paused = true; stop(); });
    hero.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', start);
    var sx = null, sy = null, moved = false;
    hero.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; stop(); });
    hero.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 10) moved = true; });
    hero.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(active + (dx < 0 ? 1 : -1));
      if (e.pointerType !== 'mouse') start();
    });
    hero.addEventListener('pointercancel', function () { sx = null; start(); });
    hero.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    hero.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) { var i = slides.indexOf(e.target); if (i > -1) { go(i); paused = true; stop(); } });
      document.addEventListener('shopify:block:deselect', function () { paused = false; start(); });
    }
    start();
  });

  /* Reveal on scroll */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (r) { io.observe(r); });
  } else reveals.forEach(function (r) { r.classList.add('is-visible'); });

  /* Collection filters & sort */
  var filterForm = $('[data-filter-form]');
  if (filterForm) filterForm.addEventListener('change', function () {
    window.location.search = new URLSearchParams(new FormData(filterForm)).toString();
  });

  /* Product recommendations (native Shopify endpoint) */
  var recs = $('[data-recommendations]');
  if (recs && !recs.children.length) {
    fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        recs.innerHTML = fresh.innerHTML;
        $$('.reveal', recs).forEach(function (r) { r.classList.add('is-visible'); });
      }
    }).catch(function () {});
  }
})();
